module.exports = __webpack_public_path__ + "static/media/wmsui32_3924.aa792367.ico";